// React
import React, { Component } from 'react'

// Libraries

// Components
import LinesContainer from '../LinesContainer'
import Line from './Line'

// Shared

export default class EmbeddableCartMobileLines extends Component {
  static displayName = 'EmbeddableCartMobileLines'

  render () {
    return (
      <div className="bq-cart-items bq-cart-items--mobile">
        <LinesContainer cleanstate component={Line} />
      </div>
    )
  }
}
